var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.00195H2C1.73478 9.00195 1.48043 8.8966 1.29289 8.70906C1.10536 8.52152 1 8.26717 1 8.00195V1.00195C1 0.736737 1.10536 0.482383 1.29289 0.294846C1.48043 0.10731 1.73478 0.00195313 2 0.00195312H12C12.2652 0.00195313 12.5196 0.10731 12.7071 0.294846C12.8946 0.482383 13 0.736737 13 1.00195V8.00195C12.9996 8.26705 12.8941 8.52117 12.7067 8.70862C12.5192 8.89607 12.2651 9.00156 12 9.00195ZM2 1.00195V8.00195H12V1.00195H2ZM0 10.002H14V11.002H0V10.002Z",
    fill: "#EE2B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceDesktop);
export default __webpack_public_path__ + "static/media/experience-desktop.14e2b89243e4612ac650bb5a3aeccd0b.svg";
export { ForwardRef as ReactComponent };